import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async syncContacts({ commit }) {
      try {
        return await api.get(`/chrons/contacts`)
      } catch (error) {
        throw error
      }
    },

    async getContacts({ commit }) {
      try {
        const response = await api.get(`/registers/contacts`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
